import styled from 'styled-components'

import { helpers } from 'styles'

export const Code = styled.code`
	overflow-wrap: anywhere;
	font-size: ${helpers.font.size.smaller};
`
